import type { AssessmentResultsByParentIdResponse } from '@risksmart-app/trpc/src/types';
import type { GetAssessmentResultsByParentIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAssessmentResultsByParentIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseGetAssessmentResultsByParentIdArgs = {
  ParentId: string;
};

export const useLazyGetAssessmentResultsByParentId = createLazyQueryHook<
  UseGetAssessmentResultsByParentIdArgs,
  AssessmentResultsByParentIdResponse,
  GetAssessmentResultsByParentIdQuery
>({
  trpcQuery: (client, args) =>
    client.frontend.assessment.resultsByParentId.query({
      parentId: args.ParentId,
    }),
  mapTrpcDataToGraphQL: (data) => ({
    document_assessment_result: data.document_assessment_result.map((r) => ({
      ...r,
      __typename: 'document_assessment_result' as const,
    })),
    obligation_assessment_result: data.obligation_assessment_result.map(
      (r) => ({
        ...r,
        __typename: 'obligation_assessment_result' as const,
      })
    ),
    risk_assessment_result: data.risk_assessment_result.map((r) => ({
      ...r,
      __typename: 'risk_assessment_result' as const,
    })),
    test_result: data.test_result.map((r) => ({
      ...r,
      __typename: 'test_result' as const,
    })),
    impact_rating: data.impact_rating,
    issue: data.issue,
    impact: data.impact,
    action: data.action,
  }),
  graphqlDocument: GetAssessmentResultsByParentIdDocument,
  graphqlVariables: (args) => ({ ParentId: args.ParentId }),
});
